module.exports = __webpack_public_path__ + "static/ChatbotRingSavvy_Img1-504358afd6508dcd27949969024bb128.png";